module.exports = __webpack_public_path__ + "static/media/SH 14-15.322a1824.mp3";